import type {
  AppSettings,
  EnvironmentSettings,
} from '../settings/fetchAppSettings'

export type EnvironmentSettingsWithApi = EnvironmentSettings & {
  api: string | null
}

const getAppSettingsFromLocalStorage = () => {
  const localStorageSettings = localStorage.getItem('appSettings')

  if (!localStorageSettings) {
    return undefined
  }

  return JSON.parse(localStorageSettings) as EnvironmentSettingsWithApi
}

export const getEnvironmentSettings = (
  environmentJson: AppSettings,
): [EnvironmentSettings, string] => {
  const { environments } = environmentJson
  const localSettings = getAppSettingsFromLocalStorage()
  const locallySelectedEnvironment = localSettings?.api

  if (!environments || !Object.keys(environments).length) {
    throw new Error('An invalid environment.json file was provided.')
  }

  const firstEnvironmentName =
    environments && !!Object.keys(environments).length
      ? Object.keys(environments)[0]
      : undefined
  const firstEnvironmentSettings = firstEnvironmentName
    ? environments[firstEnvironmentName]
    : undefined

  let api = firstEnvironmentName
  let settings = firstEnvironmentSettings

  const isCurrentEnvironmentInTheDeployedSettings =
    locallySelectedEnvironment &&
    environments &&
    locallySelectedEnvironment in environments

  if (isCurrentEnvironmentInTheDeployedSettings) {
    settings = environments[locallySelectedEnvironment]
    api = locallySelectedEnvironment
  } else if (localSettings && locallySelectedEnvironment === 'customize') {
    settings = localSettings
    api = locallySelectedEnvironment
  }

  if (!settings || !api) {
    throw new Error('Could not retrieve the current configuration.')
  }

  return [settings, api]
}
